export const DEFAULT_FONT_SIZE = 10;

/**
 * Root font size is 10px — rem() divides by 10 so `rem(16)` → `1.6rem` (16px at root 10px).
 */
export const rem = (px: number): `${number}rem` =>
  `${px / DEFAULT_FONT_SIZE}rem` as `${number}rem`;

export const spacing = {
  xs: rem(4),
  sm: rem(8),
  md: rem(16),
  lg: rem(24),
  xl: rem(32),
  xxl: rem(48),
  xxxl: rem(64),
} as const;

/**
 * Viewport height helper for layouts (e.g. full-height panels minus chrome).
 */
export const getViewHeight = (subtractPx = 0): string =>
  subtractPx <= 0 ? '100vh' : `calc(100vh - ${rem(subtractPx)})`;
